import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { API_URL } from '../../config/environment';
import api from '../../services/api';

const ReportsTab = ({
  dailyClosureReports,
  reportsLoading,
  reportFilters,
  setReportFilters,
  onLoadReports
}) => {
  const [selectedReport, setSelectedReport] = useState(null);
  const [showClosureDetailsModal, setShowClosureDetailsModal] = useState(false);

  const viewClosureDetails = async (report) => {
    try {
      const response = await api.get(`/admin/daily-closure-reports/${report.id}`);
      const data = response.data;
      if (data.success && data.data?.report) {
        // Polacz dane raportu z coupons_summary jesli dostepne
        const fullReport = {
          ...data.data.report,
          coupons_summary: data.data.coupons_summary || null
        };
        setSelectedReport(fullReport);
      } else {
        setSelectedReport(report);
      }
    } catch (error) {
      console.error('Blad:', error);
      setSelectedReport(report);
    }
    setShowClosureDetailsModal(true);
  };

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
      {/* Lista zamkniec dziennych */}
      <div style={{
        border: '1px solid var(--border)',
        borderRadius: '4px',
        backgroundColor: 'var(--card-bg)',
        overflow: 'hidden',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <div style={{
          padding: '0.4rem 0.6rem',
          background: 'linear-gradient(135deg, var(--info) 0%, var(--info) 100%)',
          borderBottom: '1px solid var(--border)',
          fontWeight: '600',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: '#fff',
          flexWrap: 'wrap',
          gap: '8px'
        }}>
          <div>
            <span style={{ fontSize: '11px' }}>Historia zamkniec dziennych</span>
            <div style={{ fontSize: '9px', fontWeight: '400', opacity: 0.9, marginTop: '2px' }}>
              Finanse - Roznice - Social Media - Osiagniecia - Notatki
            </div>
          </div>
          <div style={{ display: 'flex', gap: '4px', alignItems: 'center', flexWrap: 'wrap' }}>
            <span style={{ fontSize: '11px' }}>Od:</span>
            <input
              type="date"
              value={reportFilters.date_from}
              onChange={(e) => setReportFilters(prev => ({ ...prev, date_from: e.target.value }))}
              style={{
                padding: '6px 10px',
                border: '1px solid var(--border)',
                borderRadius: '6px',
                fontSize: '12px',
                backgroundColor: 'var(--card-bg)',
                color: 'var(--text)'
              }}
            />
            <span style={{ fontSize: '11px' }}>Do:</span>
            <input
              type="date"
              value={reportFilters.date_to}
              onChange={(e) => setReportFilters(prev => ({ ...prev, date_to: e.target.value }))}
              style={{
                padding: '6px 10px',
                border: '1px solid var(--border)',
                borderRadius: '6px',
                fontSize: '12px',
                backgroundColor: 'var(--card-bg)',
                color: 'var(--text)'
              }}
            />
            <input
              type="text"
              value={reportFilters.cashier || ''}
              onChange={(e) => setReportFilters(prev => ({ ...prev, cashier: e.target.value }))}
              placeholder="Kasjer..."
              style={{
                padding: '6px 10px',
                border: '1px solid var(--border)',
                borderRadius: '6px',
                fontSize: '12px',
                width: '90px',
                backgroundColor: 'var(--card-bg)',
                color: 'var(--text)'
              }}
            />
            <button
              onClick={onLoadReports}
              disabled={reportsLoading}
              style={{
                padding: '6px 12px',
                backgroundColor: 'var(--card-bg)',
                color: 'var(--info)',
                border: '1px solid var(--info)',
                fontSize: '12px'
              }}
            >
              {reportsLoading ? '...' : 'Szukaj'}
            </button>
          </div>
        </div>

        {/* Legenda */}
        <div style={{
          padding: '4px 8px',
          backgroundColor: 'var(--border)',
          borderBottom: '1px solid var(--border)',
          fontSize: '9px',
          color: 'var(--text-muted)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          flexWrap: 'wrap'
        }}>
          <strong>Legenda:</strong>
          <span style={{ backgroundColor: 'var(--purple-light)', padding: '1px 4px', borderRadius: '2px' }}>Social Media</span>
          <span style={{ backgroundColor: 'var(--warning-light)', padding: '1px 4px', borderRadius: '2px' }}>Osiagniecia</span>
          <span style={{ backgroundColor: 'var(--info-light)', padding: '1px 4px', borderRadius: '2px' }}>Notatki</span>
        </div>

        <div style={{ overflow: 'auto', maxHeight: '500px' }}>
          {reportsLoading ? (
            <div style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>
              <p style={{ margin: 0, fontSize: '11px' }}>Ladowanie raportow...</p>
            </div>
          ) : dailyClosureReports && dailyClosureReports.length > 0 ? (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '10px' }}>
              <thead style={{ backgroundColor: 'var(--border)', position: 'sticky', top: 0 }}>
                <tr>
                  <th style={{ padding: '6px 8px', textAlign: 'left', fontSize: '10px', fontWeight: '600', borderBottom: '1px solid var(--border)' }}>
                    Data / Kasjer
                  </th>
                  <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: '10px', fontWeight: '600', borderBottom: '1px solid var(--border)' }}>
                    Gotowka
                  </th>
                  <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: '10px', fontWeight: '600', borderBottom: '1px solid var(--border)' }}>
                    Karty
                  </th>
                  <th style={{ padding: '6px 8px', textAlign: 'right', fontSize: '10px', fontWeight: '600', borderBottom: '1px solid var(--border)' }}>
                    Roznice
                  </th>
                  <th style={{ padding: '6px 8px', textAlign: 'center', fontSize: '10px', fontWeight: '600', borderBottom: '1px solid var(--border)' }}>
                    Trans.
                  </th>
                  <th style={{ padding: '6px 8px', textAlign: 'center', fontSize: '10px', fontWeight: '600', borderBottom: '1px solid var(--border)' }}>
                    Dane
                  </th>
                  <th style={{ padding: '6px 8px', textAlign: 'center', fontSize: '10px', fontWeight: '600', borderBottom: '1px solid var(--border)' }}>
                    Akcje
                  </th>
                </tr>
              </thead>
              <tbody>
                {dailyClosureReports.map((report, index) => (
                  <tr key={report.id || index} style={{ backgroundColor: index % 2 === 0 ? 'var(--card-bg)' : 'var(--bg)' }}>
                    <td style={{ padding: '5px 8px', fontSize: '10px', borderBottom: '1px solid var(--border)' }}>
                      <div style={{ fontWeight: '600', color: 'var(--text)' }}>
                        {report.data_zamkniecia ? new Date(report.data_zamkniecia).toLocaleDateString('pl-PL') : '-'}
                      </div>
                      <div style={{ fontSize: '9px', color: 'var(--text-muted)' }}>
                        {report.kasjer_login || 'System'} - {report.czas_zamkniecia?.split('.')[0] || ''}
                      </div>
                    </td>
                    <td style={{ padding: '5px 8px', fontSize: '10px', textAlign: 'right', borderBottom: '1px solid var(--border)' }}>
                      <div style={{ fontWeight: '600', color: 'var(--success)' }}>
                        {parseFloat(report.kasa_fizyczna || 0).toFixed(2)} zl
                      </div>
                      <div style={{ fontSize: '9px', color: 'var(--text-muted)' }}>
                        sys: {parseFloat(report.kasa_system || 0).toFixed(2)} zl
                      </div>
                    </td>
                    <td style={{ padding: '5px 8px', fontSize: '10px', textAlign: 'right', borderBottom: '1px solid var(--border)' }}>
                      <div style={{ fontWeight: '600', color: 'var(--info)' }}>
                        {parseFloat(report.sprzedaz_karta || report.terminal_rzeczywisty || 0).toFixed(2)} zl
                      </div>
                      <div style={{ fontSize: '9px', color: 'var(--text-muted)' }}>
                        term: {parseFloat(report.terminal_rzeczywisty || 0).toFixed(2)} zl
                      </div>
                    </td>
                    <td style={{ padding: '5px 8px', fontSize: '10px', textAlign: 'right', borderBottom: '1px solid var(--border)' }}>
                      <div style={{
                        fontWeight: '600',
                        color: (report.roznica_kasa || 0) < 0 ? 'var(--danger)' : (report.roznica_kasa || 0) > 0 ? 'var(--success)' : 'var(--text-secondary)'
                      }}>
                        Kasa: {parseFloat(report.roznica_kasa || 0).toFixed(2)} zl
                      </div>
                      <div style={{
                        fontSize: '9px',
                        color: (report.roznica_terminal || 0) < 0 ? 'var(--danger)' : (report.roznica_terminal || 0) > 0 ? 'var(--success)' : 'var(--text-muted)'
                      }}>
                        Term: {parseFloat(report.roznica_terminal || 0).toFixed(2)} zl
                      </div>
                    </td>
                    <td style={{ padding: '5px 8px', fontSize: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)' }}>
                      <span style={{
                        padding: '2px 6px',
                        backgroundColor: 'var(--info-light)',
                        color: 'var(--info)',
                        borderRadius: '3px',
                        fontSize: '10px',
                        fontWeight: '600'
                      }}>
                        {report.liczba_transakcji || 0}
                      </span>
                    </td>
                    <td style={{ padding: '5px 8px', fontSize: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)' }}>
                      <div style={{ display: 'flex', gap: '2px', justifyContent: 'center' }}>
                        {(report.social_media_tiktok || report.social_media_facebook ||
                          report.social_media_instagram || report.social_media_google) && (
                          <span style={{
                            padding: '2px 4px',
                            backgroundColor: 'var(--purple-light)',
                            color: 'var(--purple)',
                            borderRadius: '2px',
                            fontSize: '9px'
                          }}>SM</span>
                        )}
                        {(report.osiagniecia_sprzedaz || report.osiagniecia_praca) && (
                          <span style={{
                            padding: '2px 4px',
                            backgroundColor: 'var(--warning-light)',
                            color: 'var(--warning)',
                            borderRadius: '2px',
                            fontSize: '9px'
                          }}>OS</span>
                        )}
                        {report.uwagi_zamkniecia && (
                          <span style={{
                            padding: '2px 4px',
                            backgroundColor: 'var(--info-light)',
                            color: 'var(--info)',
                            borderRadius: '2px',
                            fontSize: '9px'
                          }}>N</span>
                        )}
                      </div>
                    </td>
                    <td style={{ padding: '5px 8px', fontSize: '10px', textAlign: 'center', borderBottom: '1px solid var(--border)' }}>
                      <div style={{ display: 'flex', gap: '3px', justifyContent: 'center' }}>
                        <button
                          onClick={() => viewClosureDetails(report)}
                          style={{
                            padding: '4px 10px',
                            border: '1px solid var(--info)',
                            backgroundColor: 'var(--card-bg)',
                            color: 'var(--info)',
                            fontSize: '11px'
                          }}
                        >
                          Zobacz
                        </button>
                        <button
                          onClick={() => window.print()}
                          style={{
                            padding: '4px 10px',
                            border: '1px solid var(--success)',
                            backgroundColor: 'var(--card-bg)',
                            color: 'var(--success)',
                            fontSize: '11px'
                          }}
                        >
                          Drukuj
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div style={{ textAlign: 'center', padding: '1.5rem', color: 'var(--text-muted)' }}>
              <p style={{ margin: 0, fontSize: '11px' }}>Brak raportow zamkniec dla wybranych kryteriow</p>
            </div>
          )}
        </div>
      </div>

      {/* Modal szczegolow zamkniecia */}
      {showClosureDetailsModal && selectedReport && (
        <ClosureDetailsModal
          report={selectedReport}
          onClose={() => setShowClosureDetailsModal(false)}
        />
      )}
    </div>
  );
};

// Osobny komponent dla modala szczegolow
const ClosureDetailsModal = ({ report, onClose }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        backgroundColor: 'var(--card-bg)',
        borderRadius: '8px',
        maxWidth: '700px',
        width: '95%',
        maxHeight: '85vh',
        overflow: 'hidden',
        boxShadow: '0 4px 20px rgba(0,0,0,0.3)'
      }}>
        {/* Naglowek */}
        <div style={{
          background: 'linear-gradient(135deg, var(--info) 0%, var(--info) 100%)',
          color: '#fff',
          padding: '0.5rem 0.75rem',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div>
            <h3 style={{ margin: 0, fontSize: '12px', fontWeight: '600' }}>
              Szczegoly zamkniecia dziennego
            </h3>
            <div style={{ fontSize: '10px', opacity: 0.9, marginTop: '2px' }}>
              {report.data_zamkniecia ? new Date(report.data_zamkniecia).toLocaleDateString('pl-PL') : '-'} - {report.kasjer_login || 'System'}
            </div>
          </div>
          <div style={{ display: 'flex', gap: '0.5rem' }}>
            <button
              onClick={() => {
                const reportDate = report.data_zamkniecia || report.data_zmiany;
                const locationId = report.dcr_location_id || report.location_id;
                if (reportDate && locationId) {
                  window.open(`${API_URL}/kasa-bank/report/pdf?location_id=${locationId}&date=${reportDate}`, '_blank');
                } else {
                  toast.error('Brak danych do wygenerowania raportu');
                }
              }}
              style={{
                padding: '4px 10px',
                border: '1px solid var(--success)',
                backgroundColor: 'var(--card-bg)',
                color: 'var(--success)',
                fontSize: '11px'
              }}
            >
              Drukuj raport
            </button>
            <button
              onClick={onClose}
              style={{
                padding: '4px 10px',
                border: '1px solid var(--border)',
                backgroundColor: 'var(--card-bg)',
                color: 'var(--text-secondary)',
                fontSize: '11px'
              }}
            >
              Zamknij
            </button>
          </div>
        </div>

        <div style={{ padding: '0.5rem', overflow: 'auto', maxHeight: 'calc(85vh - 80px)' }}>
          <div style={{ display: 'grid', gap: '0.4rem' }}>

            {/* Podstawowe informacje */}
            <div style={{ padding: '0.4rem 0.5rem', backgroundColor: 'var(--bg)', borderRadius: '4px', borderLeft: '3px solid var(--text-muted)' }}>
              <h4 style={{ margin: '0 0 0.3rem 0', fontSize: '11px', fontWeight: '600', color: 'var(--text-secondary)' }}>
                Informacje podstawowe
              </h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.3rem', fontSize: '10px' }}>
                <div>
                  <span style={{ color: 'var(--text-muted)' }}>Data zamkniecia:</span><br />
                  <strong>{report.data_zamkniecia ? new Date(report.data_zamkniecia).toLocaleString('pl-PL') : '-'}</strong>
                </div>
                <div>
                  <span style={{ color: 'var(--text-muted)' }}>Uzytkownik:</span><br />
                  <strong>{report.kasjer_login || 'System'}</strong>
                </div>
                <div>
                  <span style={{ color: 'var(--text-muted)' }}>Czas zamkniecia:</span><br />
                  <strong>{report.czas_zamkniecia?.split('.')[0] || '-'}</strong>
                </div>
              </div>
            </div>

            {/* Podsumowanie finansowe */}
            <div style={{ padding: '0.4rem 0.5rem', backgroundColor: 'var(--info-light)', borderRadius: '4px', borderLeft: '3px solid var(--info)' }}>
              <h4 style={{ margin: '0 0 0.3rem 0', fontSize: '11px', fontWeight: '600', color: 'var(--info)' }}>
                Podsumowanie finansowe
              </h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.3rem', fontSize: '10px' }}>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Kasa system:</span><br />
                  <strong>{parseFloat(report.kasa_system || 0).toFixed(2)} zl</strong>
                </div>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Kasa fizyczna:</span><br />
                  <strong>{parseFloat(report.kasa_fizyczna || 0).toFixed(2)} zl</strong>
                </div>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Roznica kasa:</span><br />
                  <strong style={{
                    color: Math.abs(report.roznica_kasa || 0) < 0.01 ? 'var(--text-secondary)' : (report.roznica_kasa || 0) < 0 ? 'var(--danger)' : 'var(--success)'
                  }}>
                    {Math.abs(report.roznica_kasa || 0) < 0.01 ? 'OK' : `${parseFloat(report.roznica_kasa || 0).toFixed(2)} zl`}
                  </strong>
                </div>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Terminal:</span><br />
                  <strong>{parseFloat(report.terminal_rzeczywisty || 0).toFixed(2)} zl</strong>
                </div>
              </div>
            </div>

            {/* Saldo zmiany */}
            <div style={{ padding: '0.4rem 0.5rem', backgroundColor: 'var(--info-light)', borderRadius: '4px', borderLeft: '3px solid var(--info)' }}>
              <h4 style={{ margin: '0 0 0.3rem 0', fontSize: '11px', fontWeight: '600', color: 'var(--info)' }}>
                Saldo zmiany
              </h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.3rem', fontSize: '10px' }}>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Poczatkowe:</span><br />
                  <strong>{parseFloat(report.saldo_poczatkowe || 0).toFixed(2)} zl</strong>
                </div>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Koncowe (sys):</span><br />
                  <strong>{parseFloat(report.saldo_koncowe || report.kasa_system || 0).toFixed(2)} zl</strong>
                </div>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Koncowe (fiz):</span><br />
                  <strong>{parseFloat(report.saldo_fizyczne || report.kasa_fizyczna || 0).toFixed(2)} zl</strong>
                </div>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Roznica:</span><br />
                  <strong style={{
                    color: Math.abs(report.roznica_fizyczna || report.roznica_kasa || 0) < 0.01 ? 'var(--success)' : 'var(--danger)'
                  }}>
                    {parseFloat(report.roznica_fizyczna || report.roznica_kasa || 0).toFixed(2)} zl
                  </strong>
                </div>
              </div>
            </div>

            {/* Statystyki sprzedazy */}
            <div style={{ padding: '0.4rem 0.5rem', backgroundColor: 'var(--success-light)', borderRadius: '4px', borderLeft: '3px solid var(--success)' }}>
              <h4 style={{ margin: '0 0 0.3rem 0', fontSize: '11px', fontWeight: '600', color: 'var(--success)' }}>
                Sprzedaz wg metod platnosci
              </h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '0.3rem', fontSize: '10px' }}>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Transakcje:</span><br />
                  <strong style={{ fontSize: '12px', color: 'var(--success)' }}>{report.liczba_transakcji || 0}</strong>
                </div>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Gotowka:</span><br />
                  <strong style={{ color: 'var(--success)' }}>{parseFloat(report.sprzedaz_gotowka || 0).toFixed(2)} zl</strong>
                </div>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Karta:</span><br />
                  <strong style={{ color: 'var(--info)' }}>{parseFloat(report.sprzedaz_karta || 0).toFixed(2)} zl</strong>
                </div>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>BLIK:</span><br />
                  <strong style={{ color: 'var(--danger)' }}>{parseFloat(report.sprzedaz_blik || 0).toFixed(2)} zl</strong>
                </div>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Kupon:</span><br />
                  <strong style={{ color: 'var(--purple)' }}>{parseFloat(report.sprzedaz_kupon || 0).toFixed(2)} zl</strong>
                </div>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Kasa fiskalna:</span><br />
                  <strong>{parseFloat(report.kasa_fiskalna_raport || report.raport_fiskalny || 0).toFixed(2)} zl</strong>
                </div>
              </div>
            </div>

            {/* Terminal */}
            <div style={{ padding: '0.4rem 0.5rem', backgroundColor: 'var(--danger-light)', borderRadius: '4px', borderLeft: '3px solid var(--danger)' }}>
              <h4 style={{ margin: '0 0 0.3rem 0', fontSize: '11px', fontWeight: '600', color: 'var(--danger)' }}>
                Terminal platniczy
              </h4>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '0.3rem', fontSize: '10px' }}>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>System:</span><br />
                  <strong>{parseFloat(report.terminal_system || report.terminal_karta_system || 0).toFixed(2)} zl</strong>
                </div>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Rzeczywisty:</span><br />
                  <strong>{parseFloat(report.terminal_rzeczywisty || report.terminal_karta_rzeczywisty || 0).toFixed(2)} zl</strong>
                </div>
                <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                  <span style={{ color: 'var(--text-muted)' }}>Roznica:</span><br />
                  <strong style={{
                    color: Math.abs(report.roznica_terminal || 0) < 0.01 ? 'var(--success)' : 'var(--danger)'
                  }}>
                    {parseFloat(report.roznica_terminal || 0).toFixed(2)} zl
                  </strong>
                </div>
              </div>
            </div>

            {/* Kupony - jesli dostepne */}
            {report.coupons_summary && report.coupons_summary.total_count > 0 && (
              <div style={{ padding: '0.4rem 0.5rem', backgroundColor: 'var(--purple-light)', borderRadius: '4px', borderLeft: '3px solid var(--purple)' }}>
                <h4 style={{ margin: '0 0 0.3rem 0', fontSize: '11px', fontWeight: '600', color: 'var(--purple)' }}>
                  Kupony sprzedane
                </h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.3rem', fontSize: '10px' }}>
                  <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                    <span style={{ color: 'var(--text-muted)' }}>Razem:</span><br />
                    <strong>{report.coupons_summary.total_count} szt / {parseFloat(report.coupons_summary.total_value || 0).toFixed(2)} zl</strong>
                  </div>
                  <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                    <span style={{ color: 'var(--text-muted)' }}>Gotowka:</span><br />
                    <strong>{report.coupons_summary.gotowka?.count || 0} szt</strong>
                  </div>
                  <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                    <span style={{ color: 'var(--text-muted)' }}>Karta:</span><br />
                    <strong>{report.coupons_summary.karta?.count || 0} szt</strong>
                  </div>
                  <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                    <span style={{ color: 'var(--text-muted)' }}>BLIK:</span><br />
                    <strong>{report.coupons_summary.blik?.count || 0} szt</strong>
                  </div>
                </div>
              </div>
            )}

            {/* Social Media */}
            {(report.social_media_tiktok || report.social_media_facebook ||
              report.social_media_instagram || report.social_media_google) && (
              <div style={{ padding: '0.4rem 0.5rem', backgroundColor: 'var(--purple-light)', borderRadius: '4px', borderLeft: '3px solid var(--purple)' }}>
                <h4 style={{ margin: '0 0 0.3rem 0', fontSize: '11px', fontWeight: '600', color: 'var(--purple)' }}>
                  Social Media
                </h4>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '0.3rem', fontSize: '10px' }}>
                  {report.social_media_tiktok && (
                    <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                      <span style={{ color: 'var(--text-muted)' }}>TikTok:</span> {report.social_media_tiktok}
                    </div>
                  )}
                  {report.social_media_facebook && (
                    <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                      <span style={{ color: 'var(--text-muted)' }}>Facebook:</span> {report.social_media_facebook}
                    </div>
                  )}
                  {report.social_media_instagram && (
                    <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                      <span style={{ color: 'var(--text-muted)' }}>Instagram:</span> {report.social_media_instagram}
                    </div>
                  )}
                  {report.social_media_google && (
                    <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                      <span style={{ color: 'var(--text-muted)' }}>Google:</span> {report.social_media_google}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Osiagniecia */}
            {(report.osiagniecia_sprzedaz || report.osiagniecia_praca) && (
              <div style={{ padding: '0.4rem 0.5rem', backgroundColor: 'var(--warning-light)', borderRadius: '4px', borderLeft: '3px solid var(--warning)' }}>
                <h4 style={{ margin: '0 0 0.3rem 0', fontSize: '11px', fontWeight: '600', color: 'var(--warning)' }}>
                  Osiagniecia dnia
                </h4>
                <div style={{ fontSize: '10px' }}>
                  {report.osiagniecia_sprzedaz && (
                    <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px', marginBottom: '4px' }}>
                      <span style={{ color: 'var(--text-muted)' }}>Sprzedaz:</span> {report.osiagniecia_sprzedaz}
                    </div>
                  )}
                  {report.osiagniecia_praca && (
                    <div style={{ backgroundColor: 'var(--card-bg)', padding: '4px 6px', borderRadius: '3px' }}>
                      <span style={{ color: 'var(--text-muted)' }}>Praca:</span> {report.osiagniecia_praca}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Notatki */}
            {report.uwagi_zamkniecia && (
              <div style={{ padding: '0.4rem 0.5rem', backgroundColor: 'var(--info-light)', borderRadius: '4px', borderLeft: '3px solid var(--cyan)' }}>
                <h4 style={{ margin: '0 0 0.3rem 0', fontSize: '11px', fontWeight: '600', color: 'var(--info)' }}>
                  Notatki
                </h4>
                <div style={{ fontSize: '10px', color: 'var(--info)', whiteSpace: 'pre-wrap' }}>
                  {report.uwagi_zamkniecia}
                </div>
              </div>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ReportsTab);
